import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "none",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#275653",
			d: "M31.35 76.45H2.22c-1.5 0-2.29-1.82-1.27-2.93a125.2 125.2 0 0 0 7.84-9.28c2.23-3.04 4.89-7.45 6.5-10.2a1.76 1.76 0 0 1 3-.05c1.7 2.74 4.5 7.16 6.78 10.25 2.2 2.99 5.38 6.78 7.59 9.34a1.74 1.74 0 0 1-1.3 2.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#275653",
			d: "m-5.25 89.57 20.7-25.13a1.7 1.7 0 0 1 2.64 0l20.55 25.13a1.7 1.7 0 0 1-1.17 2.79l-20.54 1.9h-.32l-20.7-1.9a1.7 1.7 0 0 1-1.16-2.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#275653",
			d: "M39.28 103.3c-19.8 3.78-25.28 4.63-45.27.06a1.7 1.7 0 0 1-.82-2.87l9.56-9.46 12.6-13.24a1.7 1.7 0 0 1 2.51.04l11.8 13.2 10.44 9.32c1.06.94.57 2.69-.82 2.96Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_12121_22517",
			width: 49,
			height: 54,
			x: -8,
			y: 53,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#275653",
				fillRule: "evenodd",
				d: "M31.37 76.5h-3.45l10.74 13.13a1.7 1.7 0 0 1-1.17 2.78l-5.74.53 8.37 7.46c1.06.94.56 2.7-.83 2.96-19.79 3.77-25.28 4.63-45.26.05a1.7 1.7 0 0 1-.82-2.87l7.75-7.67-5.03-.46a1.7 1.7 0 0 1-1.16-2.79L5.57 76.5H2.25c-1.5 0-2.3-1.82-1.27-2.93 2.32-2.54 5.62-6.27 7.83-9.28 2.24-3.04 4.9-7.45 6.5-10.2a1.76 1.76 0 0 1 3-.05c1.7 2.74 4.51 7.16 6.78 10.25 2.2 3 5.39 6.78 7.6 9.34a1.74 1.74 0 0 1-1.31 2.87Z",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_12121_22517)",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#1D1D1D",
				fillOpacity: .39,
				d: "M30.3 107.56c4.87-15.06-3.02-25.2-13.36-54.89-8.7-13.22-18.37-31.73 13.36 0 39.67 39.66-4.8 69.77 0 54.89Z"
			}), /* @__PURE__ */ _jsx("path", {
				stroke: "#72733E",
				d: "M11.46 61.18c2.75 2.04 9.4 5.67 14 3.95.12 6.22-4.52 18.3-24.05 16.87 1.44 7.18 10.41 20.32 34.82 15.44"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.29,
			height: 1.29,
			x: 5.08,
			y: 96.72,
			fill: "#E3F510",
			rx: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.72,
			cy: 100.6,
			r: 3.24,
			fill: "#EC4E43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .43,
			d: "M6.3 98.64c.02-.48.77-.48 1.35 0 1.28 1.04.7 2.42.23 2.14-.87-.52-1.62-1.53-1.59-2.14Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.29,
			height: 1.29,
			x: 28.05,
			y: 88.82,
			fill: "#E3F510",
			rx: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.7,
			cy: 92.7,
			r: 3.24,
			fill: "#EC4E43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .43,
			d: "M29.27 90.75c.02-.49.77-.48 1.36 0 1.28 1.03.69 2.42.22 2.14-.87-.53-1.61-1.54-1.58-2.14Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.29,
			height: 1.29,
			x: 20.15,
			y: 64.41,
			fill: "#E3F510",
			rx: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20.8,
			cy: 68.29,
			r: 3.24,
			fill: "#EC4E43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .43,
			d: "M21.37 66.33c.02-.48.77-.47 1.36 0 1.28 1.04.69 2.43.22 2.15-.87-.53-1.61-1.54-1.58-2.15Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.29,
			height: 1.29,
			x: 10.1,
			y: 79.49,
			fill: "#E3F510",
			rx: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.75,
			cy: 83.37,
			r: 3.24,
			fill: "#EC4E43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillOpacity: .43,
			d: "M11.32 81.41c.02-.48.77-.48 1.36 0 1.28 1.04.69 2.42.22 2.14-.87-.52-1.61-1.53-1.58-2.14Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 19.72,
			y: 76.59,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-29 19.72 76.59)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 16,
			y: 66.24,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-156 16 66.24)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 9.67,
			y: 60.07,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-29 9.67 60.07)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 12.54,
			y: 78.74,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-29 12.54 78.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 3.92,
			y: 82.33,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-29 3.92 82.33)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 7.47,
			y: 89.56,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(45 7.47 89.56)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 11.9,
			y: 95.29,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(22 11.9 95.29)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 20.11,
			y: 96,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(10 20.1 96)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 1.44,
			height: 2.15,
			x: 28.16,
			y: 98.63,
			fill: "#FDFFB0",
			rx: .72,
			transform: "rotate(-23 28.16 98.63)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M29.97 102.03c-2.84-.13-8.27-1.18-7.25-4.4 1.02-3.22 3.3-2.38 4.3-1.56a7.91 7.91 0 0 1 2.95 5.96Zm-.92-1c-1.53-.07-4.06-.53-3.51-2.24.36-1.12 1.67-.45 1.86-.3.61.5 1.15 1.12 1.65 2.54Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M29.38 101.54c1.26-2.64 4.33-7.35 6.51-5.09 2.18 2.26.58 4.07-.5 4.7-1 .63-3.58 1.6-6 .39Zm1.09-.43c.64-1.33 2.61-3.08 3.54-2.4 1 .75.23 1.76-.32 2.07-.5.32-1.97.95-3.22.33Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBC746",
			d: "M15.72 42.5a.85.85 0 0 1 1.62 0l.7 2.15c.11.35.44.59.81.59h2.26a.85.85 0 0 1 .5 1.54l-1.82 1.33c-.3.22-.43.6-.31.96l.7 2.14a.85.85 0 0 1-1.32.96l-1.83-1.33a.85.85 0 0 0-1 0l-1.83 1.33a.85.85 0 0 1-1.31-.96l.7-2.14a.85.85 0 0 0-.32-.96l-1.82-1.33a.85.85 0 0 1 .5-1.54h2.26c.37 0 .7-.24.81-.6l.7-2.14Z"
		})
	]
});
const SvgTileBgTree = styled(base)({});
export default SvgTileBgTree;
